// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WorkflowIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WorkflowIcon" ref={forwardedRef} {...props}>
      <path d="M7.908 7.15a3 3 0 1 1 4.182.001L15.05 12h1.45a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.793l-2.506-4.104a3 3 0 0 1-1.576 0L6.706 12H7.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.448zM10 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-6 7v3h3v-3zm9 0v3h3v-3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const WorkflowIcon = /* @__PURE__ */ Object.assign(
  WorkflowIconComponent,
  { displayName: 'WorkflowIcon' },
);
